import { Switch, Route, Redirect } from 'wouter';
import Home from '@/pages/Home';
import Games from '@/pages/Games';
import Game from '@/pages/game/game';
import { Profile } from '@/pages/profile/profile';
import NotFound from '@/pages/not-found';
import { PaymentSuccess } from '@/pages/PaymentSuccess';
import { PrivateRoute } from '@/components/private-route';
import { useScript } from '@/hooks/use-script';
import { useAuth } from '@/hooks/use-auth';
import ymWrapper from '@/lib/ym';
import { useEffect } from 'react';
import { About } from '@/pages/about/about';

const UserRoutes = () => {
  useScript('https://lib.usedesk.ru/secure.usedesk.ru/widget_170408_64225.js');
  const { user } = useAuth();

  // ym initializated in user layout, user routes is it's child
  useEffect(() => {
    if (!user) return;
    ymWrapper('userParams', {
      UserID: user.id,
      email: user.email,
    });
  }, [user]);

  return (
    <Switch>
      <Route path="/">{<Redirect to="/about" />}</Route>
      <Route path="/home" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/games" component={Games} />
      <Route path="/game/:id" component={Game} />
      <PrivateRoute path="/profile" component={Profile} />
      <Route path="/payment-success" component={PaymentSuccess} />
      <Route component={NotFound} />
    </Switch>
  );
};

export { UserRoutes };
